import preventDefault from './helpers/preventDefault';

document.addEventListener('gesturestart', preventDefault);

document.addEventListener('gesturechange', preventDefault);

document.addEventListener('gestureend', preventDefault);
